// src/hooks/admin/usePropertyData.ts
import { useState, useEffect } from 'react';
import { getAdminProperties, patchAdminProperty } from '../../API/apiService';

export interface Property {
  property_id: number;
  is_published: boolean;
  name: string;
  name_en: string;
  address: string;
  address_en: string;
  station_distance: string;
  station_distance_en: string;
  area_id: number;
  area_name: string;
  area_name_en: string;
  description: string;
  description_en: string;
  site_controller_id: number;
  site_controller_property_id: string;
  region_id: number;
  latitude: string;
  longitude: string;
  postal_code: string;
  postal_code_en: string;
  room_type_description: string;
  room_type_description_en: string;
  sort_number: number;
}

export const usePropertyData = () => {
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // 管理者用物件一覧 API を呼び出し
    getAdminProperties()
      .then((response) => {
        setProperties(response.data.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching properties:', err);
        setError('Error fetching properties');
        setLoading(false);
      });
  }, []);

  // 物件更新用関数：既存のデータと更新データをマージし、全項目を patchAdminProperty に送信
  const updateProperty = async (
    updatedData: Partial<Property> & { property_id: number }
  ) => {
    const property = properties.find(
      (p) => p.property_id === updatedData.property_id
    );
    if (!property) {
      console.error('Property not found.');
      return;
    }
    // 編集対象外の項目も含め、全フィールドをマージ
    const fullData: Property = { ...property, ...updatedData };

    const fd = new FormData();
    // fullData の全フィールドをループし、undefined や null でなければ FormData に追加
    Object.entries(fullData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        let finalValue = ''; // 型注釈を削除しました
        if (typeof value === 'boolean') {
          finalValue = value ? '1' : '0';
        } else {
          finalValue = value.toString();
        }
        fd.append(key, finalValue);
      }
    });

    try {
      const response = await patchAdminProperty(
        fullData.property_id.toString(),
        fd
      );
      console.log('Property updated successfully:', response.data);
    } catch (error) {
      console.error('Error updating property:', error);
    }
  };

  return { properties, loading, error, updateProperty };
};
